export const COOKIE_PASSIVE_SESSION_ID_NAME = "d4passiveSessionId";
export const COOKIE_CUSTOMER_TOKEN_NAME = "d4customerToken";
export const COOKIE_CUSTOMER_SIGNED_TOKEN_NAME = "d4customerSignedToken";
export const COOKIE_CBT_TOKEN_NAME = "d4cbtToken";
export const COOKIE_CUSTOMER_NAME_NAME = "d4customerName";
export const COOKIE_REQUESTOR_PUBLIC_KEY = "d4requestorPublicKey";
export const COOKIE_BACKEND_ID_NAME = "backend_id";
export const COOKIE_CUSTOMER_DEVICE = "d4customerDevice";
export const COOKIE_REDIRECT_AFTER_LOGIN = "redirectAfterLogin";
